import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "../../../../services/auth.service";
import { CommonService } from "../../../../services/common.service";
import { ReservationService } from "../../../../services/reservation.service";
import { FormatterService } from "../../../../services/formatter.service";
import { AppConfig } from "../../../../configs/app";

@Component({
  selector: "page-reservation-email",
  templateUrl: "./index.component.html",
})
export class PageReservationEmailComponent implements OnInit {
  public moment: any;
  public _: any;
  public $: any;

  public reservationData: any = {};
  public activatedStation: any = {};
  public currentCancelRuleItem: any = {};

  public mailBody: any;

  constructor(
    public formatterService: FormatterService,
    public activatedRoute: ActivatedRoute,
    public authService: AuthService,
    public commonService: CommonService,
    public reservationService: ReservationService,
    public appConfig: AppConfig
  ) {
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
    this.$ = this.commonService.getJQuery();
  }

  async ngOnInit() {
    /* COMMENTED FOR PUBLIC SEARCH CHECK IF NOT LOGGED IN */
    /* if (!this.authService.isLoggedIn()) {
            return this.commonService.redirectToRoute(this.commonService.routePaths.pageHomeNoParam);
        } */

    /* SET PAGE TITLE */
    this.commonService.setTitle(`予約メール | バスブックマーク`);

    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* GET RESERVATION DATA */
    let reservationData = this.commonService.getData(
      "searchReservationDataEmail"
    );
    if (this._.isEmpty(reservationData)) {
      this.reservationData =
        await this.reservationService.getReservationDetails({
          reservationID:
            this.activatedRoute.snapshot.paramMap.get("reservationID"),
          busDetail: 1,
          emailDetail: 1,
        });
    } else {
      this.reservationData = reservationData;
    }

    if (
      this._.isEmpty(this.reservationData.reservation) ||
      this.reservationData.reservation.reservation_id !=
        this.activatedRoute.snapshot.paramMap.get("reservationID")
    ) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pageReservationListNoParam
      );
    }

    /* CALCULATE ALIGHTING DAY */
    this.reservationData.reservation.alightingDay =
      this.reservationData.reservation.dpt_ymd;

    if (this.reservationData.reservation.station_list) {
      let firstTime =
        this.reservationData.reservation.station_list[0].station_time;
      firstTime = parseInt(firstTime.replace(":", ""));

      let lastTime =
        this.reservationData.reservation.station_list[1].station_time;
      lastTime = parseInt(lastTime.replace(":", ""));

      if (firstTime > lastTime) {
        this.reservationData.reservation.alightingDay = this.moment(
          this.reservationData.reservation.alightingDay
        )
          .add(1, "days")
          .format("YYYY-MM-DD");
      }
    }

    /* CALCULATE PASSENGER */
    this.reservationData.reservation.passenger = {
      adult: {
        men: 0,
        women: 0,
      },
      children: {
        men: 0,
        women: 0,
      },
    };
    for (let passenger of this.reservationData.reservation.passenger_list) {
      if (
        passenger.price_type ==
        this.commonService.appConfig.reservation.priceType.adult
      ) {
        /* ADULT */
        if (
          passenger.sex ==
          this.commonService.appConfig.reservation.defaultUserData.sexMale
        ) {
          this.reservationData.reservation.passenger.adult.men++;
        } else if (
          passenger.sex ==
          this.commonService.appConfig.reservation.defaultUserData.sexFemale
        ) {
          this.reservationData.reservation.passenger.adult.women++;
        }
      } else if (
        passenger.price_type ==
        this.commonService.appConfig.reservation.priceType.children
      ) {
        /* CHILDREN */
        if (
          passenger.sex ==
          this.commonService.appConfig.reservation.defaultUserData.sexMale
        ) {
          this.reservationData.reservation.passenger.children.men++;
        } else if (
          passenger.sex ==
          this.commonService.appConfig.reservation.defaultUserData.sexFemale
        ) {
          this.reservationData.reservation.passenger.children.women++;
        }
      }
    }
    /* END */

    /* SET CURRENT ITEM & LAST ITEM OF CANCEL LIST */
    this.currentCancelRuleItem = { name: "無し", rate: 0 };
    this.reservationData.reservation.cancelList = {
      lastItem:
        this.reservationData.reservation.bus_detail.cancel_list[
          this.reservationData.reservation.bus_detail.cancel_list.length - 1
        ],
    };

    /* THE DAY BEFORE DEPARTURE DAY */
    this.reservationData.reservation.dayBeforeDepartureDay = this.moment(
      this.reservationData.reservation.dpt_ymd
    )
      .startOf("day")
      .diff(this.moment(Date.now()).startOf("day"), "days");
    this.reservationData.reservation.weekDay =
      this.formatterService.fullDateWithDayLabel(
        this.reservationData.reservation.dpt_ymd,
        true,
        false
      );
    this.reservationData.reservation.weekDayPayment =
      this.formatterService.fullDateWithDayLabel(
        this.reservationData.reservation.payment_date,
        true,
        false
      );

    this.reservationData.reservation.deadlinePayment =
      this.formatterService.fullDateWithDayLabel(
        this.reservationData.reservation.payment_deadline,
        true,
        false
      );
    /* EXECUTE INLINE JAVASCRIPT */
    this.inlineJS();

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  setActivatedStation(station: any = {}) {
    this.activatedStation = station;
  }

  setCurrentCancelRuleItem(item: any) {
    this.currentCancelRuleItem = item;
    return true;
  }

  setMailBody(index: any) {
    this.mailBody = this.reservationData.reservation.mail_detail[index].body;
  }

  inlineJS() {
    let self = this;
  }
}
